import paymentInstance from '../instance'

const getAdyenConnectedAccount = () => {
	return paymentInstance.get('/adyenConnectedAccounts')
}

export default getAdyenConnectedAccount
